<template>
    <FormGroupNew :label="__('general.api.settings_test')"
                  description="Please test your API credentials before saving."
                  required
    >
        <button class="btn btn-sm btn-light-primary"
                :class="{
            'btn-light-primary': apiTestSucceeded,
            'btn-warning': testRequired && !apiTestSucceeded,
            'btn-light-default': !testRequired,
        }"
                :disabled="apiTestOngoing"
                @click="testApiSettings"
        >
            <i class="fas fa-arrow-circle-right"/>
            {{ __('actions.start_thing', {thing: __('general.test')}) }}
        </button>

        <div class="mt-2 font-size-lg">
            <SpinnerWithLabel v-if="apiTestOngoing" class="mt-n2" spinner-class="spinner-sm spinner-primary">
                {{ __('general.connecting') }}...
            </SpinnerWithLabel>
            <div v-if="apiTestSucceeded === true" class="text-success">
                <i class="fas fa-check-circle"/>
                {{ __('general.thing.successful', {thing: __('general.connection')}) }}
            </div>
            <div v-if="apiTestSucceeded === false" class="text-danger">
                <i class="fas fa-times-circle"/>
                {{ __('general.thing.failed', {thing: __('general.connection')}) }}
                <div v-if="errorMessage.length > 0" class="d-inline-block">
                    :&nbsp;{{ errorMessage }}
                </div>
            </div>
            <div v-if="hasFormErrors" class="text-danger">
                <ul>
                    <li v-for="error in formErrors">
                        {{ error[0] }}
                    </li>
                </ul>
            </div>
        </div>
    </FormGroupNew>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SpinnerWithLabel from "@components/SpinnerWithLabel.vue";

export default {
    components: {
        SpinnerWithLabel,
        FormGroupNew
    },

    props: {
        configs: Object,
        testRequired: Boolean
    },

    data() {
        return {
            apiTestOngoing: false,
            apiTestSucceeded: null,
            errorMessage: '',
            formErrors: {}
        }
    },

    methods: {
        testApiSettings() {
            this.apiTestSucceeded = null;
            this.apiTestOngoing = true;

            axios.post(this.$route('integrations.PROHANDEL.test'), {
                ph_key: this.configs.ph_key,
                ph_sec: this.configs.ph_sec,
                ph_api_url: this.configs.ph_api_url,
                ph_api_version: this.configs.ph_api_version,
            }).then(response => {
                let success = response.status >= 200 && response.status < 300;
                this.apiTestSucceeded = success;
                this.apiTestOngoing = false;
                this.formErrors = {};

                if (success) {
                    this.$emit('passed')
                }
            }).catch(error => {
                this.apiTestSucceeded = false;
                this.apiTestOngoing = false;

                if (error.response.data.hasOwnProperty('errors')) {
                    this.formErrors = error.response.data.errors;
                } else if (error.response.data.hasOwnProperty('message')) {
                    this.errorMessage = error.response.data.message;
                }
            })
        }
    },

    computed: {
        hasFormErrors() {
            return Object.values(this.formErrors).length > 0;
        }
    }
}
</script>
